import { CategorizedRoutesType } from 'src/context/PrivateLayoutDrawerContext'
import { LoopModule } from 'src/services/openApiV2'

export const moduleKeyToLoopModuleMap = {
  base_routes: LoopModule.BASE,
  recover: LoopModule.RECOVER,
  guard: LoopModule.GUARD,
  balance: LoopModule.BALANCE,
  truroi: LoopModule.TRUROI,
  re_engage: LoopModule.REENG
}

export const loopModuleToModuleKeyMap = {
  [LoopModule.BASE]: 'base_routes',
  [LoopModule.RECOVER]: 'recover',
  [LoopModule.GUARD]: 'guard',
  [LoopModule.BALANCE]: 'balance',
  [LoopModule.TRUROI]: 'truroi',
  [LoopModule.REENG]: 're_engage'
}

export const modulePrefixToLoopModuleMap = {
  base: LoopModule.BASE,
  recover: LoopModule.RECOVER,
  guard: LoopModule.GUARD,
  balance: LoopModule.BALANCE,
  'tru-roi': LoopModule.TRUROI,
  're-engage': LoopModule.REENG
}

export function getModuleFromPathname(pathname: string, categorizedRoutes?: CategorizedRoutesType[]): LoopModule | null {
  if (categorizedRoutes) {
    let cleanPathname = pathname
    if (cleanPathname.startsWith('/')) {
      cleanPathname = cleanPathname.substring(1)
    }

    const module = categorizedRoutes.find((item) =>
      item.routes.some((route) => {
        try {
          return route.key === cleanPathname || route.subNav?.map((sub) => route.key + '/' + sub.key).includes(cleanPathname)
        } catch (e) {
          return false
        }
      })
    )

    return moduleKeyToLoopModuleMap[module?.category?.key] || null
  }

  return modulePrefixToLoopModuleMap[pathname?.split('/')?.[0]] || null
}

export const getModuleRouteFromPathname = (pathname: string, categorizedRoutes?: CategorizedRoutesType[]): string | null => {
  return loopModuleToModuleKeyMap[getModuleFromPathname(pathname, categorizedRoutes)] || 'base_routes'
}
